import { NgModule } from '@angular/core';
import { ImportModule } from '../import.module';
import { MainItemModule } from '../components/(items)/main-item/main-item.module';
import { Routes, RouterModule } from '@angular/router';
import { MainItemComponent } from '../components/(items)/main-item/main-item.component';
const routes: Routes = [
  {
    path: '',
    component: MainItemComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [ImportModule, RouterModule.forChild(routes), MainItemModule],
})
export class WrapperMainItemModule {}
